import { Component } from '@angular/core';
import { GlobalserviceService } from './globalservice.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  loaderStatus: Boolean = true;
  constructor(public common: GlobalserviceService) {
    this.common.getLoaderStatus().subscribe(result => {
      this.loaderStatus = result;
    })
  }
}